import { BODY_TYPE_GROUPS, BODY_TYPE_LABEL, type BodyType } from 'shared';

interface Props {
  value: BodyType | '';
  onChange: (v: BodyType | '') => void;
  /** Текст пункта «любой». Пусто — пункт не показываем. */
  anyLabel?: string;
}

/**
 * Выбор кузова из полного справочника.
 *
 * Сорок с лишним позиций одним списком не выбрать, поэтому они разложены
 * по группам: универсальные, температурные, наливные и так далее.
 */
export default function BodyTypeSelect({ value, onChange, anyLabel }: Props) {
  return (
    <select value={value} onChange={(e) => onChange(e.target.value as BodyType | '')}>
      {anyLabel && <option value="">{anyLabel}</option>}
      {BODY_TYPE_GROUPS.map((g) => (
        <optgroup key={g.title} label={g.title}>
          {g.types.map((t) => (
            <option key={t} value={t}>
              {BODY_TYPE_LABEL[t]}
            </option>
          ))}
        </optgroup>
      ))}
    </select>
  );
}

/** Кузова чипами — для множественного выбора при публикации. */
export function BodyTypeChips({
  value,
  onToggle,
}: {
  value: BodyType[];
  onToggle: (t: BodyType) => void;
}) {
  return (
    <>
      {BODY_TYPE_GROUPS.map((g) => (
        <div key={g.title} style={{ marginBottom: 8 }}>
          <div className="meta" style={{ marginBottom: 4 }}>
            {g.title}
          </div>
          <div className="chips">
            {g.types.map((t) => (
              <button
                key={t}
                type="button"
                className={`chip ${value.includes(t) ? 'on' : ''}`}
                onClick={() => onToggle(t)}
              >
                {BODY_TYPE_LABEL[t]}
              </button>
            ))}
          </div>
        </div>
      ))}
    </>
  );
}
